import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from './contexts/ThemeContext';
import ContentUpdateListener from './components/ContentUpdateListener';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import ProductListing from './pages/ProductListing';
import CategoryPage from './pages/CategoryPage';
import TagFilterPage from './pages/TagFilterPage';
import ProductDetail from './pages/ProductDetail';
import Wishlist from './pages/Wishlist';
import ShopCart from './pages/ShopCart';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import OrderConfirmation from './pages/OrderConfirmation';
import Orders from './pages/Orders';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import About from './pages/About';
import Standalone from './pages/Standalone';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';

function App() {
  return (
    <ThemeProvider>
      <Router>
        {/* Scroll to top on route change */}
        <ScrollToTop />
        <div className="App">
          {/* WebSocket listener for real-time content updates */}
          <ContentUpdateListener />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product-listing" element={<ProductListing />} />
            <Route path="/category/:categorySlug" element={<CategoryPage />} />
            <Route path="/products" element={<TagFilterPage />} />
            <Route path="/product-detail" element={<ProductDetail />} />
            <Route path="/product-detail/:id" element={<ProductDetail />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/shop-cart" element={<ShopCart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/about" element={<About />} />
            <Route path="/standalone" element={<Standalone />} />
            <Route path="/privacy-policy" element={<Standalone />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
          </Routes>
          <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
